/* eslint-disable react-hooks/exhaustive-deps */
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef, GridRowProps, GridRowsProp } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useSelector } from "src/stateManagement/redux";
import { HistoricalActivitiesDetails } from "./components/HistoricalActivitiesDetails";
import './historyDetail.scss'
import moment from "moment";
import { Box, IconButton, Typography } from "@mui/material";
import { tableStyles } from "src/shared/util/tableStyles";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export const HistoricalActividades = () => {
    const { fieldActivities } = useSelector((state) => state.location);
    const [data, setData] = useState<any>();
    const [activityType, setActivityType] = useState("");
    const [showDetails, setShowDetails] = useState(false);

    const [dataForTable, setDataForTable] = useState<any[]>([])

    useEffect(() => {
        const dataForTable = fieldActivities.map((activity: any) => {

            const valTest = activity?.variables?.find((variable: any) => variable.id === "8a8c2c05-d3b1-410c-bb3e-a8fd717f0e86");
            const pressureText = activity?.variables?.find((variable: any) => variable.id === "e377cb89-3cf0-422f-a05b-a17f73187544");


            return {
                ...activity,
                presureTestExecuted: pressureText ? pressureText.value === 'true' : false,
                valveTestExecuted: valTest ? valTest.value === 'true' : false,
            }
        })

        setDataForTable(dataForTable);
    }, [fieldActivities])


    const handleShowDetails = (data: any, type: any, executedDate: string, enginner: string) => {
        setData({
            variables: data,
            typeOfActivity: type,
            executedDate: executedDate,
            executedBy: enginner
        });
        setActivityType(type);
        setShowDetails(true);
    };

    const columns: GridColDef[] = [
        {
            field: "executedDate",
            headerName: "Fecha",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
            type: "number",
            valueGetter: (_value, row) => {
                const raw = row?.executedDate;
                if (!raw) return 0;
                const ts = new Date(raw).getTime();
                return Number.isFinite(ts) ? ts : 0;
            },
            sortComparator: (v1, v2) => (Number(v1) || 0) - (Number(v2) || 0),
            renderCell: (params) => {
                const executedDate = params.row.executedDate
                    ? moment(params.row.executedDate).local().format("DD-MM-YY")
                    : "No ejecutado";

                return (
                    <Typography
                        variant="body2"
                        sx={{
                            height: "100%",
                            display: "flex",
                            textWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {executedDate}
                    </Typography>
                );
            },
        },
        {
            field: "executedBy",
            headerName: "Responsable",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "typeOfActivity",
            headerName: "Tipo de Actividad",
            flex: 0.5,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "comments",
            headerName: "Comentario",
            headerAlign: "center",
            flex: 1,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            sx={{
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                lineHeight: "1.4",
                                py: "5px",
                                px: "2px",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                display: "-webkit-box",
                            }}
                        >
                            {params.row.comments}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "presureTestExecuted",
            headerName: "PP",
            flex: 0.3,
            type: "boolean",
        },
        {
            field: "valveTestExecuted",
            headerName: "PV",
            flex: 0.3,
            type: "boolean",
        },
        {
            field: "actions",
            headerAlign: "center",
            align: "center",
            headerName: "Opciones",
            flex: 0.2,
            renderHeader: () => (
                <IconButton onClick={() => console.log("Header action")}>
                    <MoreVertIcon />
                </IconButton>
            ),
            renderCell: (params) => {
                return (
                    <IconButton
                        size="small"
                         onClick={() =>
                            handleShowDetails(
                                params.row.variables,
                                params.row.typeOfActivity,
                                params.row.executedDate,
                                params.row.executedBy
                            )
                        }
                    >
                        <MoreVertIcon />
                    </IconButton>
                    // <Button
                    //     variant="contained"
                    //     size="small"
                      
                    // >
                    //     Detalles
                    // </Button>
                );
            },
        },
    ];

    const rows: GridRowsProp = dataForTable.map((item: any) => {
        return {
            fieldActivityId: item.fieldActivityId,
            executedDate: item.executedDate,
            operationFinalStatus: item.operationFinalStatus,
            operationInitialStatus: item.operationInitialStatus,
            optimizationActivityId: item.optimizationActivityId,
            presureTestExecuted: item.presureTestExecuted,
            status: item.status,
            typeOfActivity: item.typeOfActivity,
            valveTestExecuted: item.valveTestExecuted,
            variables: item.variables,
            diagnosticVariables: item.diagnosticVariables,
            comments: item.comments,
            executedBy: item.executedBy,
        };
    });

    const paginationModel = { page: 0, pageSize: 10 };
    return (
        <Grid container spacing={0}>
            {showDetails ? (
                <HistoricalActivitiesDetails
                    setShowDetails={setShowDetails}
                    details={data}
                    activityType={activityType}
                />
            ) : (
                <Grid size={12}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{
                            pagination: { paginationModel },
                            sorting: {
                                sortModel: [{ field: "executedDate", sort: "desc" }],
                            },
                        }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{
                            height: {
                                md: `calc(100vh - 375px)`,
                                lg: `calc(100vh - 375px)`,
                                xl: `calc(100vh - 383px)`,
                            },
                            ...tableStyles,
                        }}
                        getRowId={(row) => row.fieldActivityId}
                    />
                </Grid>
            )}
        
        </Grid>
    );
};
